import 'whatwg-fetch';
import MicroModal from 'micromodal/dist/micromodal.min.js';
import DocReady from 'es6-docready';
DocReady(function () {
  MicroModal.init({
    disableScroll: true,
    disableFocus: false,
    awaitCloseAnimation: true,
    debugMode: false
  });
  var modalTriggers = [].slice.call(document.querySelectorAll('[data-modal]'));
  var addClassOnType = function addClassOnType(trigger, modal) {
    if (trigger.matches('[data-modal-type="fullScreen"]')) {
      modal.classList.add('modal--full-screen');
    } else {
      modal.classList.remove('modal--full-screen');
    }
    if (trigger.matches('[data-modal-type="secondary"]')) {
      modal.classList.add('modal--secondary');
    } else {
      modal.classList.remove('modal--secondary');
    }
  };
  modalTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      var modalData = trigger.getAttribute('data-modal');
      var modalEntity = document.querySelector('.modal');
      addClassOnType(trigger, modalEntity);
      beforeOpenModal();
      MicroModal.show('modal');
      fetch("/modal/".concat(modalData), {
        headers: {
          'Content-Type': 'text/html'
        }
      }).then(function (response) {
        return response.text();
      }).then(function (resp) {
        if (!resp) {
          return;
        }
        var modalContent = document.querySelector('.modal__content-wrapper');
        modalContent.innerHTML = resp;
        var scripts = [].slice.call(modalContent.querySelectorAll('script'));
        scripts.forEach(function (script) {
          var tag = document.createElement('script');
          tag.innerHTML = script.innerHTML;
          modalContent.appendChild(tag);
        });
      })["catch"](function (error) {
        return console.error('Error:', error);
      });
    });
  });
});
var beforeOpenModal = function beforeOpenModal() {
  var modalContent = document.querySelector('.modal__content-wrapper');
  modalContent.innerHTML = "\n    <div class=\"modal__loader-container\">\n      <div class=\"modal__loader-bars\"><div></div><div></div><div></div><div></div><div></div></div>\n    </div>\n  ";
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    clearModal();
  }, false);
};
var clearModal = function clearModal() {
  var modalContent = document.querySelector('.modal__content-wrapper');
  modalContent.innerHTML = '';
};
var clearModalOnTouchClick = function clearModalOnTouchClick(event) {
  if (event.target.matches('[data-micromodal-close]')) {
    clearModal();
  }
};
document.addEventListener('click', clearModalOnTouchClick);